import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';

@Component({
  selector: 'app-page-unauthorized',
  templateUrl: './page-unauthorized.component.html',
  styleUrls: ['./page-unauthorized.component.css']
})
export class PageUnauthorizedComponent implements OnInit {

  isDisabled: boolean = true;
  cdnUrl:string;

  constructor() {
    this.cdnUrl = environment.hostUrl+environment.dokuFramework;
   }

  ngOnInit() {
    if (localStorage.getItem('token') !== null) {
      this.isDisabled = false;
    }
  }

  goBack() {
    if (this.isInIframe()) {
      top.window.location.href = environment.hostUrl + environment.loginPage;
      return false;
    } else {
      window.location.href = NavigationConstant.HOME;
      return false;
    }
  }

  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

}
